<template>
<div class="chapter">
<div class="inner_page">
<p class="fmtitle"><a id="page_xiii"><span class="line">PRIME MINISTERS FROM 1945</span></a></p><a id="page_xiii">
<p class="noindenta">Clement Attlee, Labour, 1945–51</p>
<p class="noindenta">Winston Churchill, Conservative, 1951–55</p>
<p class="noindenta">Anthony Eden, Conservative, 1955–57</p>
<p class="noindenta">Harold Macmillan, Conservative, 1957–63</p>
<p class="noindenta">Alec Douglas-Home, Conservative, 1963–64</p>
<p class="noindenta">Harold Wilson, Labour, 1964–70</p>
<p class="noindenta">Edward Heath, Conservative, 1970–74</p>
<p class="noindenta">Harold Wilson, Labour, 1974–76</p>
<p class="noindenta">James Callaghan, Labour, 1976–79</p>
<p class="noindenta">Margaret Thatcher, Conservative, 1979–90</p>
<p class="noindenta">John Major, Conservative, 1990–97</p>
<p class="noindenta">Tony Blair, Labour, 1997–2007</p>
<p class="noindenta">Gordon Brown, Labour, 2007–10</p>
<p class="noindenta">David Cameron, Conservative, 2010–16</p>
<p class="noindenta">Theresa May, Conservative, 2016–</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 09_Fm02.vue?982888ce